<template>
  <div id="dialog-desc" class="ugc-terms-conditions-new-modal-text">
    <p>{{ translations.termsConditionTopMessage }}</p>
    <ul class="ugc-terms-list check">
      <li v-show="!!translations.termsConditionText1">
        <span class="icon-success"></span>
        {{ translations.termsConditionText1 }}
      </li>
      <li v-show="!!translations.termsConditionText2">
        <span class="icon-success"></span>
        {{ translations.termsConditionText2 }}
      </li>
      <li v-show="!!translations.termsConditionText3">
        <span class="icon-success"></span>
        {{ translations.termsConditionText3 }}
      </li>
      <li v-show="!!translations.termsConditionText4">
        <span class="icon-success"></span>
        {{ translations.termsConditionText4 }}
      </li>
      <li v-show="!!translations.termsConditionText5">
        <span class="icon-success"></span>
        {{ translations.termsConditionText5 }}
      </li>
    </ul>

    <ul class="ugc-terms-list x">
      <li v-show="!!translations.termsConditionText6">
        <span class="icon-circle-with-plus"></span>
        <span > {{ translations.termsConditionText6 }} </span>
      </li>
      <li v-show="!!translations.termsConditionText7">
        <span class="icon-circle-with-plus"></span>
       {{ translations.termsConditionText7 }}
      </li>
      <li v-show="!!translations.termsConditionText8">
        <span class="icon-circle-with-plus"></span>
        {{ translations.termsConditionText8 }}
      </li>
    </ul>

    <div class="ugc-terms-conditions-new-modal-text-content-rights row">
      <div class="small-12">
        <strong>{{ translations.termsConditionContentRights }}</strong> {{ translations.termsConditionContentRights2 }}
      </div>
    </div>

    <div
      v-show="!!translations.contactFormDesc && !!translations.contactFormDesc2" class="row contact-form-legal-text"
    >
        {{translations.contactFormDesc}}
        <a v-show="!!translations.contactFormLinkDesc" :href="translations.contactFormLink" target="_blank">{{translations.contactFormLinkDesc}}</a>{{translations.contactFormDesc2}}<a v-show="!!translations.contactFormLinkDesc2" :href="translations.contactFormLink2" target="_blank"> {{translations.contactFormLinkDesc2}}</a>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    showBackButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    termsAssetSizeText() {
      return this.$store.state.utils.pdm.assetsSizeTranslationKey || 'termsConditionList4';
    },
  },
  methods: {
  },
  created() {
    this.$emit('showCtaButton', false);
    this.$emit('blockCtaPrimaryButton', false);
    this.$emit('showBackButton', this.showBackButton);
    this.$emit('showIconButton', true);
  }
}
</script>
